import localStore from 'store'
import { getOrCreateDeviceId } from 'utils/cookies'

/**
 * Konteks pemilik antrean aktif (user login + endpoint tenant). Diisi oleh hook
 * `useAsyncQueueSync` (yang punya akses redux) supaya modul non-React (uploader,
 * enqueue) tak perlu mengimpor store. Endpoint dibaca langsung dari localStore.
 */
let currentUserId = null

export const setQueueUserId = (userId) => {
  currentUserId = userId ?? null
}

export const getActiveEndpoint = () => localStore.get('app.endpoint') || ''

/** Pemilik antrean aktif, atau null bila belum login. */
export const getQueueOwner = () => {
  if (currentUserId == null) {
    return null
  }
  return { userId: currentUserId, endpoint: getActiveEndpoint() }
}

/** device_id browser ini (sama dengan X-Device-Token & pendaftaran device POS). */
export const getQueueDeviceId = () => getOrCreateDeviceId()

/**
 * Status Mode Zero-Loading untuk modul non-React (wrapper detail produk/barcode):
 * true bila mode ON & katalog tenant aktif sudah tersinkron. Disetel saat render
 * oleh hook layout kasir.
 */
let localCatalogReady = false
let stockWarehouseIds = []

export const setLocalCatalogReady = (ready) => {
  localCatalogReady = !!ready
}

export const isLocalCatalogReady = () => localCatalogReady

/** Gudang outlet + rak-raknya: target stok yang diambil untuk baris cart. */
export const setStockWarehouseIds = (ids) => {
  stockWarehouseIds = (ids || []).filter(Boolean)
}

export const getStockWarehouseIds = () => stockWarehouseIds
